// extracted by mini-css-extract-plugin
export default {"root":"Complete_root__36TH7","result":"Complete_result__13eVI","icon":"Complete_icon__1L84A","content":"Complete_content__JEIFw"};